import $ from 'jquery';
import '../vendors/select2';

// Default select
$( '.c-select select' ).select2( {
    minimumResultsForSearch: Infinity,
    dropdownCssClass: "c-select__dropdown",
} );


$('.event-form-select').select2({
  minimumResultsForSearch: 5,
  dropdownCssClass: "c-select__dropdown",
});

// Marketo form select
function mktoSelect() {
    $( '.mktoForm select' ).wrap("<div class='c-select'></div>");
    $( '.mktoForm select' ).select2( {
        minimumResultsForSearch: Infinity,
        dropdownCssClass: "c-select__dropdown",
    } );
}

setTimeout(mktoSelect, 1000)

// Lang switcher select
$( '.c-lang-switcher select, c-select--gray select' ).select2( {
    minimumResultsForSearch: Infinity,
    dropdownCssClass: "c-lang-switcher__dropdown",
} );

// Provider finder form select
$( '.c-provider-finder__select select' ).select2( {
    minimumResultsForSearch: Infinity,
    dropdownCssClass: "c-provider-finder__dropdown",
} );

$( '.c-provider-finder__select--treatment select' ).select2( {
    minimumResultsForSearch: Infinity,
    closeOnSelect: false,
    allowClear: false,
    id: 59,
    placeholder: CYNO_DATA.filter_labels.any,
    dropdownCssClass: "c-provider-finder__dropdown c-provider-finder__dropdown--multiple"
} ).on("change", function (e) {
    var counter = $(this).parent().find('.select2-selection__choice').length;
    $(this).parent().parent().find('.c-provider-finder__counter').html('(' + counter + ' ' + CYNO_DATA.filter_labels.selected + ')');
    if (counter > 0) {
        $(this).parent().parent().find('.select2-search__field').hide();
    } else {
        $(this).parent().parent().find('.select2-search__field').show();
    }
});

$(function() {
    var counter = $('.c-provider-finder__select--treatment').find('.select2-selection__choice').length;
    $('.c-provider-finder__counter').eq(0).html('(' + counter + ' ' + CYNO_DATA.filter_labels.selected + ')');
    if (counter > 0) {
        $('.c-provider-finder__select--treatment').find('.select2-search__field').hide();
    }
});

// Product finder form select

$( '.c-provider-finder__select--product select' ).select2( {
    minimumResultsForSearch: Infinity,
    closeOnSelect: false,
    allowClear: false,
    id: 59,
    placeholder: CYNO_DATA.filter_labels.any,
    dropdownCssClass: "c-provider-finder__dropdown c-provider-finder__dropdown--multiple"
} ).on("change", function (e) {
    var counter = $(this).parent().find('.select2-selection__choice').length;
    $(this).parent().parent().find('.c-provider-finder__counter').html('(' + counter + ' ' + CYNO_DATA.filter_labels.selected + ')');
    if (counter > 0) {
        $(this).parent().parent().find('.select2-search__field').hide();
    } else {
        $(this).parent().parent().find('.select2-search__field').show();
    }
});

$(function() {
    var counter = $('.c-provider-finder__select--product').find('.select2-selection__choice').length;
    $('.c-provider-finder__counter').eq(1).html('(' + counter + ' ' + CYNO_DATA.filter_labels.selected + ')');
    if (counter > 0) {
        $('.c-provider-finder__select--product').find('.select2-search__field').hide();
    }
});


// Footer Find a provider

$( '.c-select--treatment select').select2( {
    minimumResultsForSearch: Infinity,
    closeOnSelect: false,
    allowClear: false,
    placeholder: CYNO_DATA.filter_labels.select_treatment_any,
    dropdownCssClass: "c-select__dropdown c-select__dropdown--multiple"
}).on("change", function (e) {
    var counter = $(this).parent().find('.select2-selection__choice').length;

    if (counter > 0) {
        $(this).parent().parent().find('.c-select__counter').show().html('(' + counter + ' ' + CYNO_DATA.filter_labels.selected + ')');
        $(this).parent().parent().find('.select2-search__field').hide();
    } else {
        $(this).parent().parent().find('.c-select__counter').hide();
        $(this).parent().parent().find('.select2-search__field').show();
    }
});

$(function() {
    var counter = $('.c-select--treatment select').find('.select2-selection__choice').length;
    if (counter > 0) {
        $('.c-select__counter').html('(' + counter + ' ' + CYNO_DATA.filter_labels.selected + ')');
        $('.c-select--treatment').find('.select2-search__field').hide();
    }
});

$( '.c-select--product select').select2( {
    minimumResultsForSearch: Infinity,
    closeOnSelect: false,
    allowClear: false,
    placeholder: CYNO_DATA.filter_labels.select_product_any,
    dropdownCssClass: "c-select__dropdown c-select__dropdown--multiple"
}).on("change", function (e) {
    var counter = $(this).parent().find('.select2-selection__choice').length;

    if (counter > 0) {
        $(this).parent().parent().find('.c-select__counter').show().html('(' + counter + ' ' + CYNO_DATA.filter_labels.selected + ')');
        $(this).parent().parent().find('.select2-search__field').hide();
    } else {
        $(this).parent().parent().find('.c-select__counter').hide();
        $(this).parent().parent().find('.select2-search__field').show();
    }
});

$(function() {
    var counter = $('.c-select--product select').find('.select2-selection__choice').length;
    if (counter > 0) {
        $('.c-select__counter').html('(' + counter + ' ' + CYNO_DATA.filter_labels.selected + ')');
        $('.c-select--product').find('.select2-search__field').hide();
    }
});

// Disable Chrome autocomplete

$(function () {
    $('.c-provider-finder__select--treatment input').attr('autocomplete', 'disabled');
});
